<script setup lang="ts">
import { ScalarIconSparkle } from '@scalar/icons'

import { useAgentContext } from '@/hooks/use-agent'
import { useI18n } from '@/i18n'

const agentContext = useAgentContext()
const { t } = useI18n()
</script>

<template>
  <button
    class="bg-sidebar-b-search text-sidebar-c-2 hover:text-sidebar-c-1 flex items-center gap-1.5 rounded border px-2 text-base whitespace-nowrap"
    type="button"
    @click="agentContext?.toggleAgent()">
    <ScalarIconSparkle />
    {{ t('agent.askAi') }}
  </button>
</template>
